import {
  ANALYTICS,
  BENEFICIARIES,
  VIRTUAL_ACCOUNTS,
  VIRTUAL_ACCOUNT_CREATE,
  CHANGE_PASSWORD,
  COLLECT_PAYMENT,
  DASHBOARD,
  INVENTORY,
  LOANS,
  POS_DETAILS,
  POS_MANAGEMENT,
  POS_PAYMENT_METHOD,
  POS_REQUEST_REVIEW,
  POS_VIEW_OFFER,
  PROFILE_MANAGEMENT,
  SEND_MONEY,
  SETTINGS,
  STATEMENTS,
  SYSTEM_PREFERENCE,
  TEAM_MANAGEMENT,
  TRANSACTIONS,
  TRANSACTIONS_REFUND,
  TRANSACTIONS_TRANSACTION_DETAILS,
  TRANSACTION_PIN,
  TWO_FACTOR_AUTH,
} from "@zenith/routes/paths";

/**
 * Get the path name page title.
 * @function
 * @name getPageTitle
 * @kind function
 * @param {string} pathName The intended path.
 * @returns {string} The page title.
 * @exports
 */
export function getPageTitle(pathName: string): string {
  if (pathName.startsWith(`${VIRTUAL_ACCOUNTS}/`)) return "Virtual Accounts";

  switch (pathName) {
    case DASHBOARD:
      return "Home";
    case COLLECT_PAYMENT:
      return "Collect Payment";
    case TRANSACTIONS:
    case TRANSACTIONS_TRANSACTION_DETAILS:
    case TRANSACTIONS_REFUND:
      return "Transactions";
    case SEND_MONEY:
      return "Send Money";
    case POS_MANAGEMENT:
    case POS_VIEW_OFFER:
    case POS_DETAILS:
    case POS_REQUEST_REVIEW:
    case POS_PAYMENT_METHOD:
      return "POS Management";
    case BENEFICIARIES:
      return "Beneficiaries";
    case VIRTUAL_ACCOUNTS:
    case VIRTUAL_ACCOUNT_CREATE:
      return "Virtual Accounts";
    case LOANS:
      return "Loans";
    case ANALYTICS:
      return "Analytics";
    case SETTINGS:
    case PROFILE_MANAGEMENT:
    case TRANSACTION_PIN:
    case CHANGE_PASSWORD:
    case TWO_FACTOR_AUTH:
    case TEAM_MANAGEMENT:
    case SYSTEM_PREFERENCE:
      return "Settings";
    case STATEMENTS:
      return "Statements";
    case INVENTORY:
      return "Inventory";
    default:
      return "";
  }
}
